const InputPlaceholder = ({ label, placeholder = 'Laden...' }) => {
    return (
        <div>
            {label && (
                <span className='mb-1 block text-sm/6 font-medium text-gray-900'>
                    {label}
                </span>
            )}
            <div className='flex w-full animate-pulse items-center rounded-md bg-gray-50 px-3 py-1.5 text-base text-gray-400 outline-1 -outline-offset-1 outline-gray-200 sm:text-sm/6'>
                {placeholder}
            </div>
        </div>
    );
};

export default InputPlaceholder;
